import React from 'react';
import { Element as SlateElement } from 'slate';
import { RenderElementProps, RenderLeafProps } from 'slate-react';
import { FontSize } from './richText';

export const renderElement = (props: RenderElementProps) => (
  <Element {...props} />
);

export const renderLeaf = (props: RenderLeafProps) => <Leaf {...props} />;

const Element: React.FC<RenderElementProps> = ({
  attributes,
  children,
  element,
}) => {
  const { fontSize } = element as SlateElement & { fontSize?: FontSize };
  const sizeMap: Record<FontSize, string> = {
    small: '14px',
    normal: '16px',
    medium: '18px',
    huge: '22px',
  };
  const style: React.CSSProperties = fontSize
    ? { fontSize: sizeMap[fontSize] }
    : {};

  switch ((element as SlateElement).type) {
    case 'unorderedList': {
      return (
        <ul
          {...attributes}
          style={{
            ...style,
            listStyleType: 'disc',
            paddingLeft: '1.5rem',
            margin: 0,
          }}
        >
          {children}
        </ul>
      );
    }
    case 'orderedList': {
      return (
        <ol
          {...attributes}
          style={{
            ...style,
            listStyleType: 'decimal',
            paddingLeft: '1.5rem',
            margin: 0,
          }}
        >
          {children}
        </ol>
      );
    }
    case 'list-item':
      return (
        <li {...attributes} style={style}>
          {children}
        </li>
      );
    case 'link':
      return (
        <a
          {...attributes}
          className="text-[#7C3AED] underline underline-offset-2"
          href={(element as SlateElement & { url: string }).url}
          target={
            (element as SlateElement & { openInNewTab?: boolean }).openInNewTab
              ? '_blank'
              : undefined
          }
          rel={
            (element as SlateElement & { openInNewTab?: boolean }).openInNewTab
              ? 'noreferrer'
              : undefined
          }
        >
          {children}
        </a>
      );
    default:
      return (
        <p {...attributes} style={style}>
          {children}
        </p>
      );
  }
};

const Leaf: React.FC<RenderLeafProps> = ({ attributes, children, leaf }) => {
  let child = children;

  if (leaf.bold) {
    child = <strong>{child}</strong>;
  }

  if (leaf.italic) {
    child = <em>{child}</em>;
  }

  if (leaf.underline) {
    child = <u>{child}</u>;
  }

  return <span {...attributes}>{child}</span>;
};
